<ms-help-box boxType="transactionBets" *ngIf="isTransactionBetsHelpBoxVisible" (closeButtonClick)="onTransactionBetsHelpBoxClose()">
    <div class="transaction-bets" (click)="openTransactionBetsPopup()">{{ sitecore.betslip.transactionBetsHelpBox.Title }}</div>
</ms-help-box>
